import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { LOAD, LOAD_END } from '../../../../../../../../store/actions/actionsTypes'
import { Pallets } from '../../../../../../../modules/API/Pallets/pallets'
import { IPalletDetails } from '../../../../../../../modules/API/Pallets/models/palletDetails'
import { handleNotifications } from '../../../../../../../generic/utils/handleNotifications'
import usePrint from '../../../../../../../generic/hooks/usePrint'

const PRINTER_NUM = 33

const useCheckPallet = () => {
    const dispatch = useDispatch()

    const {
        file,
        setPdfFromBlob,
        handleSharePdf,
        handleDownloadPdf,
        handleClearFile,
        handleOpenPdf,
    } = usePrint()

    const [palletNum, setPalletNum] = useState<string>('')
    const [rows, setRows] = useState<IPalletDetails[] | null>(null)
    const [isOpenRemark, setIsOpenRemark] = useState(false)
    const [selectedRow, setSelectedRow] = useState<IPalletDetails | null>(null)

    const loadPallet = async (code: string) => {
        if (!code) return
        dispatch({ type: LOAD })
        try {
            const data = await Pallets.getPalletItems(Number(code))
            setPalletNum(code)
            setRows(Array.isArray(data?.detailsPallet) ? data.detailsPallet : [])
        } catch (err) {
            console.log(err)
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const updateRowComment = (recID: number, text: string) => {
        setRows((prev) => prev?.map((r) => (r.RecID === recID ? { ...r, CheckComment: text } : r)) ?? prev)
    }

    const openRemark = (row: IPalletDetails) => {
        setSelectedRow(row)
        setIsOpenRemark(true)
    }

    const closeRemark = () => {
        setIsOpenRemark(false)
        setSelectedRow(null)
    }

    const handleSaveRemark = (text: string) => {
        if (selectedRow) updateRowComment(selectedRow.RecID, text)
        closeRemark()
    }

    const saveComments = async () => {
        if (!rows) return
        dispatch({ type: LOAD })
        try {
            await Pallets.savePalletComments(palletNum, {
                detailsDelivery: rows.map((r) => ({ RecID: r.RecID, CheckComment: r.CheckComment ?? '' })),
                printerNum: PRINTER_NUM,
            })
            handleNotifications('נשמר בהצלחה', { type: 'success' })
        } catch (err: any) {
            handleNotifications(err?.response?.data?.message || 'שגיאה בשמירה', { type: 'error' })
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const handlePrint = async () => {
        if (!palletNum) return
        dispatch({ type: LOAD })
        try {
            const blob = await Pallets.getPalletPdf(palletNum)
            setPdfFromBlob(blob, `${palletNum}.pdf`)
        } catch (err) {
            console.log(err)
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const canSave = !!rows && rows.length > 0

    const remarkProps = {
        isActive: true,
        handleSave: handleSaveRemark,
        close: closeRemark,
        data: {
            title: selectedRow?.ProductDesc?.trim() ?? '',
            body: selectedRow?.CheckComment ?? '',
            id: selectedRow?.RecID ?? '',
        },
    }

    return {
        rows,
        palletNum,
        loadPallet,
        saveComments,
        canSave,
        isOpenRemark,
        openRemark,
        closeRemark,
        remarkProps,
        handlePrint,
        file,
        handleSharePdf,
        handleDownloadPdf,
        handleClearFile,
        handleOpenPdf,
    }
}

export default useCheckPallet
